import * as Styled from './Node.styles';

type NodeProps = {
  name: string;
  origin: string;
  recycleRate: number;
};

const Node = ({ name, origin, recycleRate }: NodeProps) => {
  return (
    <Styled.NodeContainer>
      <Styled.Component>
        <Styled.ComponentName>{name}</Styled.ComponentName>
        <Styled.ComponentRecycleRate>
          <Styled.Recycle />
          {recycleRate}%
        </Styled.ComponentRecycleRate>
      </Styled.Component>
      <Styled.Origin>{origin}</Styled.Origin>
    </Styled.NodeContainer>
  );
};

export default Node;
